import axios from 'axios';

// Production API URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.bringit.co.in/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('partnerToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Partner API
export const partnerAPI = {
  register: (data: any) => api.post('/partners/register', data),
  login: (credentials: any) => api.post('/partners/login', credentials),
  getProfile: () => api.get('/partners/profile'),
  updateProfile: (data: any) => api.put('/partners/profile', data),
  toggleAvailability: () => api.patch('/partners/availability'),
  getAvailableOrders: () => api.get('/partners/available-orders'),
  acceptOrder: (orderId: string) => api.post(`/partners/accept-order/${orderId}`),
  rejectOrder: (orderId: string, reason: string) => 
    api.post(`/partners/reject-order/${orderId}`, { reason }),
  updateOrderStatus: (orderId: string, status: string) => 
    api.patch(`/partners/order-status/${orderId}`, { status }),
  getCurrentOrder: () => api.get('/partners/current-order'),
  getDeliveryHistory: () => api.get('/partners/delivery-history'),
  getEarnings: () => api.get('/partners/earnings'),
  
  // Enhanced flow
  updateLocation: (latitude: number, longitude: number) => 
    api.patch('/partners/location', { latitude, longitude }),
  updateOrderStatusEnhanced: (orderId: string, data: any) => 
    api.patch(`/partners/order-status-enhanced/${orderId}`, data),
  generateDeliveryOTP: (orderId: string) => 
    api.post(`/partners/generate-delivery-otp/${orderId}`),
  confirmDelivery: (orderId: string, data: { otp: string; tip?: number }) => 
    api.post(`/partners/confirm-delivery/${orderId}`, data),
  
  // Payment & Profile
  requestPayment: () => api.post('/partners/payment-request'),
  getPaymentRequests: () => api.get('/partners/payment-requests'),
  
  // Direct Custom Order - Send payment info to customer
  sendPaymentRequest: (orderId: string, data: { 
    qrCodeImage: string;
    storePhone: string;
    storeName: string;
    amount: number;
    message?: string;
  }) => api.post(`/orders/${orderId}/direct-payment-request`, data),
  
  // Confirm customer payment received
  confirmCustomerPayment: (orderId: string, data: { receiptImage?: string }) => 
    api.post(`/orders/${orderId}/confirm-customer-payment`, data),
};

export default api;
